
    <mat-list *ngIf="appointments">
      <mat-list-item *ngFor="let appt of appointments">
        {{ appt.startLocal | localizedDate: 'longDate' }}, {{ appt.startLocal | localizedDate: 'shortTime' }}
      </mat-list-item>
    </mat-list>
